import {
  CreateFieldInput,
  CreateFormActions,
  CreateNextSteps,
  PageTitle
} from '../../components.js';
import { Page } from '../base.js';

export class AuthCreate extends Page {
  static nextSteps = [
    { icon: 'mail', label: 'Configure email templates' },
    { icon: 'link', label: 'Add redirect URLs' },
    { icon: 'users', label: 'Manage team access' },
    { icon: 'code', label: 'Integrate with your app' }
  ];

  static timlComponents = {
    CreateFieldInput,
    CreateFormActions,
    CreateNextSteps,
    PageTitle
  };

  static get formAction() {
    return API.resourceUrl('authConfigs');
  }

  static timl = `
    .auth-create-page
      <PageTitle title="Create Authentication App">
      .auth-create-content
        p.auth-create-description Add a new authentication app to manage registration, login, and access.
        .create-page-grid
          form.create-form-card[method="POST" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/auth"]
            .create-form-body
              <CreateFieldInput label="Name" name="name" placeholder="e.g. My App" hint="A friendly name to identify this authentication app.">
              <CreateFieldInput label="Domain (optional)" name="domain" value="https://" placeholder="e.g. https://auth.myapp.com" hint="The domain you will use for authentication links and redirects." required="false">
            <CreateFormActions submitLabel="Create" cancelHref="/auth">
          <CreateNextSteps items="{{ Routing.routeObject.nextSteps }}">
  `;
}
